// extracted by mini-css-extract-plugin
export default {"checkbox":"flight-information-form_checkbox__vEoxn"};